import React from 'react';
import { MBOverlay } from '@shared/util/overlay';
import { ReactionPicker } from '../ReactionPicker';
import { MBReactionButton } from '../button';
import { MBReactionButtonWithPickerProps } from './props';
import { pickerPositionFromButtonPosition } from './util';

/*
    Combine a reaction button with a reaction picker when pressed.
*/
export class MBReactionButtonWithPicker extends React.PureComponent<MBReactionButtonWithPickerProps> {
  showPicker = () => {
    const { selected, onToggleReaction, pickerBottomMargin, testID } = this.props;
    MBOverlay.show({
      parent: this,
      position: ({ top: y, left: x, width, height }) =>
        pickerPositionFromButtonPosition({ x, y, width, height }, pickerBottomMargin),
      closeOnBackdropPress: true,
      // TODO(fant): figure out how to make this HOC situation nicer
      component: ({ close }) => (
        <ReactionPicker
          selected={selected}
          onToggleReaction={(reactionType, add) => {
            close();
            onToggleReaction(reactionType, add);
          }}
          testID={testID ? `${testID}-picker` : undefined}
        />
      ),
    });
  };

  render() {
    const { testID } = this.props;
    return <MBReactionButton onPress={this.showPicker} testID={testID} />;
  }
}
